import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { SupportProvider, useSupport } from '../../context/support/SupportContext';
import SupportHeader from './sections/Header/SupportHeader';
import TravellerChatWorkspace from './sections/TravellerChat/TravellerChatWorkspace';
import HelpdeskWorkspace from './sections/Helpdesk/HelpdeskWorkspace';

const SupportContent = () => {
  const { currentTab } = useSupport();

  return (
    <div>
      <SupportHeader />
      {currentTab === 'travellers' ? (
        <TravellerChatWorkspace />
      ) : (
        <HelpdeskWorkspace />
      )}

      <style
        dangerouslySetInnerHTML={{
          __html: `
            .custom-scrollbar::-webkit-scrollbar {
              width: 4px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: #E5E7EB;
              border-radius: 10px;
            }
          `
        }}
      />
    </div>
  );
};

const SupportPage = () => {
  return (
    <SupportProvider>
      <MainLayout activeTab="support">
        <PageContainer className="font-sans">
          <SupportContent />
        </PageContainer>
      </MainLayout>
    </SupportProvider>
  );
};

export default SupportPage;
